import React from 'react';
import { Button, Chip, Divider, Grid, Typography } from '@mui/material';
import { Download, OpenInNew } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { KeyedMutator } from 'swr/_internal';
import { AccountData } from '../../api';
import { CHROME_WEB_STORE_URL, EXTENSION_GUIDE_URL } from '../extensionLinks';
import { MessageShortcutsSettings } from './MessageShortcutsSettings';

type ExtensionSettingsProps = {
  account: AccountData;
  updateLocalAccount: KeyedMutator<AccountData>;
  setIsUpdatedSnackOpen: (open: boolean) => void;
};

export const ExtensionSettings = ({ account, updateLocalAccount, setIsUpdatedSnackOpen }: ExtensionSettingsProps) => {
  const { t } = useTranslation();

  return (
    <Grid container flexDirection="column" flexWrap="nowrap" gap={2} maxWidth={720}>
      <Grid container flexDirection="column" flexWrap="nowrap" gap={1}>
        <Grid container alignItems="center" gap={1}>
          <Typography variant="h6">{t('extensionSettings.intro.title')}</Typography>
          <Chip size="small" label={t('extensionSettings.intro.chip')} />
        </Grid>
        <Typography variant="body2">{t('extensionSettings.intro.description')}</Typography>
        <Grid container gap={1} flexDirection={{ xs: 'column', md: 'row' }} alignItems={{ md: 'center' }}>
          <Button
            variant="outlined"
            startIcon={<Download />}
            href={CHROME_WEB_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ width: { xs: '100%', md: 'auto' } }}>
            {t('extensionSettings.intro.install')}
          </Button>
          <Button
            variant="text"
            startIcon={<OpenInNew />}
            href={EXTENSION_GUIDE_URL}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ width: { xs: '100%', md: 'auto' } }}>
            {t('extensionSettings.intro.guide')}
          </Button>
        </Grid>
      </Grid>
      <Divider />
      <MessageShortcutsSettings
        account={account}
        updateLocalAccount={updateLocalAccount}
        setIsUpdatedSnackOpen={setIsUpdatedSnackOpen}
      />
    </Grid>
  );
};
